import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {SpinnerColor, SpinnerSize} from './types';
import {template} from './template';
import css from './index.styl?inline';

export interface SpinnerJsxProps {
  attrs?: {
    'allow-festive'?: boolean;
    color?: SpinnerColor;
    size?: SpinnerSize;
  };
}

export class Spinner extends Component<EmptyObj, SpinnerJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<SpinnerJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      'allow-festive': {
        type: `boolean`,
        description: `shows a festive mode spinner if is festive`,
      },
      color: {type: `string`, enum: Object.values(SpinnerColor), default: SpinnerColor.Blue},
      size: {type: `string`, enum: Object.values(SpinnerSize), default: SpinnerSize.Small},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const SpinnerEl = defineAndMakeJsxFactory<SpinnerJsxProps>(`mp-spinner`, Spinner);
